import type { CSSProperties } from "react";
import { buildIconDataUrl, CANVAS_ICON_LIBRARY } from "./iconLibrary";

type IconPickerPanelProps = {
  isOpen: boolean;
  panelStyle?: CSSProperties;
  mainColor: string;
  onActivate?: () => void;
  onClose: () => void;
  onPick: (iconId: string) => void;
};

export function IconPickerPanel({
  isOpen,
  panelStyle,
  mainColor,
  onActivate,
  onClose,
  onPick,
}: IconPickerPanelProps) {
  if (!isOpen) return null;

  return (
    <aside
      className="absolute left-32 top-7 z-20 flex w-[360px] flex-col gap-3 rounded-[6px] border border-[rgba(74,58,31,0.12)] bg-[rgba(245,240,230,0.98)] p-3 shadow-[0_20px_40px_rgba(58,45,20,0.14)] backdrop-blur-[10px]"
      style={panelStyle}
      onMouseDownCapture={onActivate}
      onFocusCapture={onActivate}
    >
      <div className="flex items-center justify-between gap-3">
        <h3 className="m-0 text-[11px] font-bold uppercase tracking-[0.08em] text-[#4b3e27]">
          Icons
        </h3>
        <button
          type="button"
          className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-[rgba(74,58,31,0.14)] bg-white text-[#4b3e27] transition active:scale-110"
          aria-label="Close icons"
          title="Close icons"
          onClick={onClose}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="h-4 w-4 fill-none stroke-current">
            <path d="M6 6l12 12M18 6 6 18" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <div className="grid grid-cols-5 gap-2">
        {CANVAS_ICON_LIBRARY.map((icon) => (
          <button
            key={icon.id}
            type="button"
            className="flex aspect-square items-center justify-center rounded-md border border-[rgba(74,58,31,0.12)] bg-white p-2 transition hover:border-[#1d5cab] hover:bg-[#eef5ff] active:scale-110"
            aria-label={icon.label}
            title={`${icon.label} - click to preview`}
            onClick={() => onPick(icon.id)}
          >
            <img src={buildIconDataUrl(icon.id, mainColor)} alt="" aria-hidden="true" className="h-full w-full" />
          </button>
        ))}
      </div>
    </aside>
  );
}
